import DoubleRowCarousel from '../../../components/DoubleRowCarousel/DoubleRowCarousel';

const carouselData = [
  {
    name: 'Sajin Raj Amatya',
    role: 'Mental Health Counseling User',
    message: 'It was a great experience to get advice for improvement. My counselor provided a safe space and practical strategies that truly helped me cope better.',
  },
  {
    name: 'Arth Bhattarai',
    role: 'Psychological Counseling Client',
    message: 'I loved working with the team, they are truly professionals! I felt understood and supported throughout my sessions, which made a significant difference in my well-being.',
  },
  {
    name: 'Rijan Rai',
    role: 'Career Counselee',
    message: 'Their guidance in exploring career options was top-notch, highly recommended! I now have a much clearer direction for my professional life.',
  },
  {
    name: 'Swornim Ratna Shakya',
    role: 'Scholarship Applicant',
    message: 'Smooth communication and great support in navigating the scholarship application process! Their advice significantly improved my chances.',
  },
  {
    name: 'Soniya Dhakal',
    role: 'Academic Guidance Seeker',
    message: 'The best team I have collaborated with so far! Their insights into choosing the right academic path were incredibly helpful.',
  },
  {
    name: 'Shreyak Karmacharya',
    role: 'Education Counseling Client',
    message: 'Great experience! I learned a lot from this collaboration about different educational opportunities that I hadnt considered before.',
  },
  {
    name: 'Sandeep Acharya',
    role: 'Mental Health Counseling User',
    message: 'Delivered high-quality support on time, highly satisfied. My counselor was empathetic and provided effective coping mechanisms.',
  },
  {
    name: 'Rahul Joshi',
    role: 'Psychological Counseling Client',
    message: 'They exceeded my expectations in every aspect. I feel much more self-aware and equipped to handle challenges after my sessions.',
  },
  {
    name: 'Titas Gurung',
    role: 'Career Counselee',
    message: 'Great team! I appreciate their dedication and professionalism in helping me identify my career strengths and goals.',
  },
  {
    name: 'Prasikchya Mote',
    role: 'Scholarship Applicant',
    message: 'They ensure top-notch quality in every project they handle, including guiding me through crafting compelling scholarship essays.',
  },
  {
    name: 'Milan Khanal',
    role: 'Academic Guidance Seeker',
    message: 'Their guidance on academic planning and study skills was top-notch, highly recommended! My grades have improved significantly.',
  },
  {
    name: 'Sandesh Aryal',
    role: 'Education Counseling Client',
    message: 'Smooth communication and a great understanding of the educational landscape! They helped me find the perfect program for my needs.',
  },
  {
    name: 'Saman Joshi',
    role: 'Mental Health Counseling User',
    message: 'The best team I have collaborated with so far for my mental well-being. I always felt heard and supported.',
  },
  {
    name: 'Doulat Thapa',
    role: 'Psychological Counseling Client',
    message: 'Great experience! I learned a lot from this collaboration about myself and how to navigate my emotions effectively.',
  },
  {
    name: 'Simran Kapoor Thakur',
    role: 'Career Counselee',
    message: 'Delivered high-quality career advice on time, highly satisfied. I now have a clear career path Im excited about.',
  },
  {
    name: 'Bikram Rai',
    role: 'Scholarship Applicant',
    message: 'They exceeded my expectations in every aspect of the scholarship application process. I received more offers than I anticipated!',
  },
  {
    name: 'Simran Kapoor Thakur',
    role: 'Academic Guidance Seeker',
    message: 'Great team! I appreciate their dedication and professionalism in helping me achieve my academic goals.',
  },
  {
    name: 'Rahul Joshi',
    role: 'Education Counseling Client',
    message: 'They ensure top-notch quality in every project they handle, including providing comprehensive guidance on educational opportunities.',
  },
];

const TestimonialSection = () => {
  return <DoubleRowCarousel data={carouselData} />;
};

export default TestimonialSection;